/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./index.css";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0, // Adjust as needed
  environment: process.env.REACT_APP_ENV || 'DEV'
});

// Sentry.init({
//   dsn: "https://174c1baf352c49d48a00955e6a1fad63@o4504484740923392.ingest.sentry.io/4504655589343232",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// }); 


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
if (process.env.NODE_ENV === "production") {
  console.log = () => { }
  console.debug = () => { }
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
